/**
 * CenterSlice
 * 
 * Redux slice for managing center selection state.
 * 
 * This slice follows the modular pattern with:
 * - state.ts: State interface and initial state
 * - selectors.ts: Memoized selectors
 * - reducers/: Split reducer files by domain
 */

import { createSlice } from '@reduxjs/toolkit';
import { initialState, CenterSliceState } from './state';

// Import all reducers with Reducer suffix
import { setSelectedCenterReducer } from './reducers';

/**
 * Center slice definition
 */
const centerSlice = createSlice({
  name: 'center',
  initialState,
  reducers: {
    setSelectedCenter: setSelectedCenterReducer,
  },
});

// Export actions
export const centerActions = centerSlice.actions;

// Export both original names AND Action-suffixed names for flexibility
export const { setSelectedCenter } = centerSlice.actions;
export const { setSelectedCenter: setSelectedCenterAction } = centerSlice.actions;

// Export reducer
export default centerSlice.reducer;

// Re-export state types
export type { CenterSliceState } from './state';

// Re-export selectors
export * from './selectors';
